import { COLOR_TOKENS } from '../colors/colors';
export var SHADOWS = {
    'shadow-xs': "0px 0px 0 ".concat(COLOR_TOKENS['Colors/Base/Black']),
    'shadow-sm': "2px 2px 0 ".concat(COLOR_TOKENS['Colors/Base/Black']),
    'shadow-md': "3px 3px 0 ".concat(COLOR_TOKENS['Colors/Base/Black']),
    'shadow-lg': "4px 4px 0 ".concat(COLOR_TOKENS['Colors/Base/Black']),
    'shadow-xl': "8px 8px 0 ".concat(COLOR_TOKENS['Colors/Base/Black']),
    'shadow-2xl': "12px 12px 0 ".concat(COLOR_TOKENS['Colors/Base/Black']),
    'shadow-3xl': "16px 16px 0 ".concat(COLOR_TOKENS['Colors/Base/Black']),
    'shadow-focus-ring-brand': "0px 0px 0px 2px ".concat(COLOR_TOKENS['Colors/Border/border-brand']),
    'shadow-skeumorphic-inner-border': "0px 0px 0px 1px rgba(10, 13, 18, 0.18) inset",
    'shadow-skeumorphic-inner': "0px -2px 0px 0px rgba(10, 13, 18, 0.05) inset",
    'shadow-skeumorphic-outer': "0px 1px 2px 0px rgba(10, 13, 18, 0.05)",
    'shadow-xs-skeuomorphic': [
        "0px 0px 0px 1px rgba(10, 13, 18, 0.18) inset",
        "0px -2px 0px 0px rgba(10, 13, 18, 0.05) inset",
        "0px 1px 2px 0px rgba(10, 13, 18, 0.05)",
    ].join(', '),
};
